import { render, staticRenderFns } from "./MoreColor.vue?vue&type=template&id=7b2bf35d&scoped=true&"
import script from "./MoreColor.vue?vue&type=script&lang=js&"
export * from "./MoreColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2bf35d",
  null
  
)

export default component.exports